import jsPDF from "jspdf";
import "jspdf-autotable";
// Date Fns is used to format the dates we receive
// from our API call
import { format } from "date-fns";
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es')
// define a generatePDF function that accepts a tickets argument
const generatePDFConc = (conc,action) => {
    // initialize jsPDF
    const doc = new jsPDF();
  
    // define the columns we want and their titles
    const tableColumn = ["Nombre", "Email", "País"];
    // define an empty array of rows
    const tableRows = [];
  
    // for each ticket pass all its data into an array
    conc.forEach(c => {
        console.log()
      const concData = [
        c.name,
        c.email,
        c.country,
      ];
      tableRows.push(concData);
    });
  
    // startY is basically margin-top
    doc.autoTable(tableColumn, tableRows, { startY: 20 });
    const date = Date().split(" ");
    // we use a date string to generate our filename.
    const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
    // ticket title. and margin-top + margin-left
    doc.text("Reporte de Concursantes", 14, 15);
    // we define the name of our PDF file.
    doc.save(`reporte_conc_${dateStr}.pdf`);
  };

const generatePDFPlay = (plays,action,sort = false,addCountry=false,country = '') => {
  // initialize jsPDF
  const doc = new jsPDF();

  // define the columns we want and their titles
  
  const tableColumn = ["Número", "Título", "Autor(es)", "Fecha",];
  if (addCountry){
    tableColumn.push('País')
  }

  // define an empty array of rows
  const tableRows = [];
  const tableRowsP = [];
  const tableRowsN = [];
  const tableRowsE = [];

  // for each ticket pass all its data into an array
  plays.forEach(play => {
    const playData = [
        play.code,
        play.title,
        play.authorStr,
        play.date,
      // called date-fns to format the date on the ticket
    ];
    if(addCountry){
      playData.push(country)
    }
    // push each tickcet's info into a row

    tableRows.push(playData);
  });


  // startY is basically margin-top
  moment.locale('es')
  var today = moment(Date.now())

  const date = Date().split(" ");
  // we use a date string to generate our filename.
  const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
  // ticket title. and margin-top + margin-left
//   doc.text("Closed tickets within the last one month.", 14, 15);
  // we define the name of our PDF file.
  doc.text(`Premio Casa de Composición 2023`, 55, 15);
  doc.text(`${today.format('LL')}`, 80, 25);
  doc.text("Reporte de Obras", 8, 30);

  
  doc.autoTable(tableColumn, tableRows, { startY: 35 });


  // doc.save(`reporte_obras_${dateStr}.pdf`);
if(action=="save"){
  doc.save(`reporte_obras_${dateStr}.pdf`);
}
else{
  doc.setProperties({
    title: `reporte_obras_${dateStr}.pdf`
    });
    doc.output('dataurlnewwindow');
}

  
  // doc.open()
};

export default generatePDFPlay;